<template>
    <div>
        <preloader :display="loading" />
        <div class="row">
            <div class="col span_6">
                <h1>{{ $l10n.__('Votre carte de paiement') }}</h1>
                <ul class="list-inline">
                    <li v-if="!!customerCreditCard">
                        <credit-card-template :creditcard="customerCreditCard" />
                    </li>
                    <li v-else>
                        <credit-card-template
                            :validationInProgress="cardValidationInProgress"
                            :validationMessage="$t.__('common.labels.card_being_validated')"
                            :placeholder="$t.__('common.labels.no_card_saved')"
                        />
                    </li>
                </ul>
            </div>
            <div class="col span_6">
                <h1 class="mb-5">{{ $l10n.__('Ajouter une carte de paiement') }}</h1>
                <p>{{ $l10n.__('Ou définir une nouvelle carte de paiement') }}</p>
                <div style="height: 50px">
                    <el-form
                        ref="stripeForm"
                        label-position="top"
                        :inline="false"
                        :inline-message="true"
                        :model="stripeForm"
                    >
                        <el-form-item :label="$t.__('common.labels.credit_card')" prop="creditcard">
                            <div id="creditcard">
                                <!-- A Stripe Element will be inserted here. -->
                            </div>
                        </el-form-item>
                    </el-form>
                </div>

                <span class="red error" v-if="errors.get('card-number')"
                    >{{ errors.get('card-number') }}<br
                /></span>
                <span class="red error" v-if="errors.get('card-expiry')"
                    >{{ errors.get('card-expiry') }}<br
                /></span>
                <span class="red error" v-if="errors.get('card-cvc')"
                    >{{ errors.get('card-cvc') }}<br
                /></span>

                <a
                    role="button"
                    @click.prevent="submitForm('stripeForm', 'saveNewCard')"
                    class="btn btn-primary btn-block mt-5"
                >
                    {{ $l10n.__('Enregistrer le moyen de paiement') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import FormMixins from '../../../mixins/FormMixins';
import StripeMixins from '../../../mixins/StripeMixins';
import SAMMixins from '../../../mixins/subscription/SAMMixins';
import CreditCardTemplate from './CreditCardTemplate.vue';
import WidgetMixins from '../../../mixins/sellsyaccountmanager/widgetMixins';
import Env from 'Services/Env';

export default {
    props: {
        corporation: {
            type: String | Number,
            required: true,
        },
    },
    mixins: [StripeMixins, FormMixins, SAMMixins, WidgetMixins],
    data() {
        return {
            stripeForm: {},
            loadedInMixin: true,
            loading: false,
            cardValidationInProgress: false,
            publishableKey: Env.get('stripe').publishableKey,
        };
    },

    methods: {
        refreshCreditcard() {
            this.loading = true;
            return this.getActiveCreditCard(this.corporation)
                .then((card) => {
                    this.stripeElement.clear();
                    if (card.error) {
                        this.setCustomerCreditCard(false);
                        this.cardValidationInProgress = true;
                    } else {
                        this.setCustomerCreditCard(card);
                    }
                })
                .finally(() => (this.loading = false));
        },
        removeCard() {
            /** @todo not implemented yet */
        },
        stripeInitElements() {
            if (this.billingSettings.paymentMethod == 'manual') return;
            this.stripeElement = this.stripeResources.lib
                .elements()
                .create('card', { hidePostalCode: true });
            this.stripeElement.mount('#creditcard');
            this.$emit('load', false);
        },
        saveNewCard() {
            this.loading = true;
            this.stripeCreateCardToken()
                .then((token) => this.recordStripeToken(this.corporation, token.id))
                .then(() =>
                    Push.success(this.$l10n.__('Les informations bancaires ont été enregistrées')),
                )
                .then(() => {
                    setTimeout(() => this.refreshCreditcard(), 500);
                })
                .catch((e) =>
                    Push.error(this.$l10n.__('Les informations bancaires saisies sont invalides')),
                )
                .finally((e) => (this.loading = false));
        },
    },
    components: {
        Preloader,
        CreditCardTemplate,
    },
};
</script>

<style scoped lang="scss"></style>
